module.exports = __webpack_public_path__ + "img/davaprowebicon.0de102fa.svg";